var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 15h-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 14.875c-.06903559 0-.125.0559644-.125.125s.05596441.125.125.125.125-.0559644.125-.125-.05596441-.125-.125-.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5 11h-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 2v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5 2v3"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 16.5,
    rx: 3,
    width: 18,
    x: 3,
    y: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 10.875c-.06903559 0-.125.0559644-.125.125s.05596441.125.125.125.125-.0559644.125-.125-.05596441-.125-.125-.125"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarList);
export default __webpack_public_path__ + "static/media/calendar-list.853a74ccc5f65c1c8d9460c2da73f2cf.svg";
export { ForwardRef as ReactComponent };